import { useRouter } from "next/router"
import { useCallback, useState } from "react"

import { useRevokeSessionMutation } from "features/api/auth"
import {
  useClearStaffAttributionPinMutation,
  useGetCurrentUserQuery,
} from "features/api/company"

import { PIN_CHANGED_LS_KEY } from "./PINModal"

export function useSignOut() {
  const { currentData: currentUserData } = useGetCurrentUserQuery({})
  const hasAttributionStaff =
    currentUserData?.user?.attributionStaff !== undefined

  const [revokeSession, { error: revokeSessionError }] =
    useRevokeSessionMutation()
  const [clearStaffAttributionPin, { error: clearStaffAttributionPinError }] =
    useClearStaffAttributionPinMutation()
  const [isSigningOut, setIsSigningOut] = useState(false)
  const router = useRouter()

  const signOut = useCallback(
    async ({
      full = false,
      redirect = true,
      pinSignOutRedirectTo,
    }: {
      full?: boolean
      redirect?: boolean
      pinSignOutRedirectTo?: string
    } = {}) => {
      try {
        setIsSigningOut(true)
        if (hasAttributionStaff && !full) {
          await clearStaffAttributionPin({}).unwrap()
          localStorage.setItem(PIN_CHANGED_LS_KEY, Date.now().toString())
          if (pinSignOutRedirectTo) {
            router.push(pinSignOutRedirectTo)
          }
          return
        }
        await revokeSession({}).unwrap()
        if (redirect) {
          router.push("/auth/sign-in")
        }
      } finally {
        setIsSigningOut(false)
      }
    },
    [hasAttributionStaff, clearStaffAttributionPin, revokeSession, router]
  )

  return {
    signOut,
    isSigningOut,
    error: revokeSessionError || clearStaffAttributionPinError,
  }
}
